import React, { FC } from 'react';
import { Button } from 'fronton-react';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { ChevronDownIcon, ChevronUpIcon } from '@fronton/icons-react';
import { fadeButton, openButton } from './fade-button.styles';
import { FadeButtonProps } from './fade-button.types';

export const FadeButton: FC<FadeButtonProps> = ({ open, onClick, className }) => {
  const { t } = useTranslation();
  return (
    <Button
      className={cx(fadeButton, open ? null : openButton, className)}
      kind="regular"
      variant="secondary"
      size="s"
      rounded
      iconOnly
      label={open ? t('ui.buttons.expand') : t('ui.buttons.collapse')}
      onClick={onClick}
      data-qa="collapse-button"
    >
      {open ? <ChevronDownIcon /> : <ChevronUpIcon />}
    </Button>
  );
};
